import { IconButton, Box } from '@mui/material';
import Iconify from 'src/components/iconify';
import { RHFAutocomplete } from '../hook-form';
import { useBoolean } from 'src/hooks/use-boolean';

const DropDownAddValueWrapper = ({
  name,
  label,
  options = [],
  url,
  reload,
  InstantCreateComponent,
}) => {
  const add = useBoolean();

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'start' }}>
        <RHFAutocomplete
          sx={{ width: '100%' }}
          name={name}
          label={label}
          options={options}
          getOptionLabel={(option) => option?.name || ''}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          )}
        />
        <IconButton
          onClick={() => add.onTrue()}
          className="cardColor"
          sx={{
            margin: '5px 10px',

            color: '#FFF',
            fontSize: 25,
            padding: '7px',
            borderRadius: '50%',
            '&:hover': {
              backgroundColor: '#7AB13A',
            },
            boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Iconify icon="mingcute:add-line" />
        </IconButton>
      </Box>

      <InstantCreateComponent
        label={label}
        url={url}
        reload={reload}
        open={add.value}
        onClose={add.onFalse}
      />
    </>
  );
};

export default DropDownAddValueWrapper;
